import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { Grid, Paper, TextField } from "@material-ui/core";
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';
import { backendDateFormat, fieldDateFormat } from '../../../constants';
import { withRouter } from 'react-router';
import { checkApiStatus } from '../../utils_v2';
import { ExportMenu, PageLoader } from '../../shared_elements';
import { globalGetService, globalPostService } from '../../../globalServices';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { checkPermission } from '../../../console_management/utils_v2';
import { gaTelesisInstance, jetStreamInstance, titanAviInstance } from '../../../shared/components';

const CustAcStatement = ({ ownerList, assetList, lessee }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState({});
    const [start_date, setStartDate] = useState('');
    const [end_date, setEndDate] = useState('');
    const [lessor_name_id, setLessor_name_id] = useState([]);
    const [selectAllLessor, setSelectAllLessor] = useState(false);
    const [updateForm, setUpdateForm] = useState(false);
    const [selectedLessee, setLessee] = useState([]);
    const [assetId, setAssetId] = useState([]);
    const [aircraft, setAircraft] = useState([]);
    const [aircraftId, setAircraftId] = useState([]);
    const [engineTypes, setEngineTypes] = useState([]);
    const [engineId, setEngineId] = useState([]);
    const [apuTypes, setApuTypes] = useState([]);
    const [apuId, setApuId] = useState([]);
    const [country, setCountry] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState([])
    const [invoiceType, setInvoiceType] = useState([]);
    const [assetStatus, setAssetStatus] = useState([]);

    useEffect(() => {
        getAircraft();
        getEngineTypes();
        getApuTypes();
        getCountryList();
    }, []);
    const getAircraft = () => {
        globalGetService(`console/aircraft-types/?lite=true`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setAircraft(response.data.data.aircraftTypes)
                }
            })
    }
    const getEngineTypes = () => {
        globalGetService(`console/engine-types/`, { lite: true })
            .then(response => {
                if (checkApiStatus(response)) {
                    setEngineTypes(response.data.data.engineTypes)
                }
            })
    }
    const getApuTypes = () => {
        globalGetService('console/apu-types/')
            .then(response => {
                if (checkApiStatus(response)) {
                    setApuTypes(response.data.data.apu_types);
                }
            })
    }
    const getCountryList = () => {
        globalGetService('console/country-list/')
            .then(response => {
                if (checkApiStatus(response)) {
                    setCountry(response.data.data);
                }
            })
    }
    const exportAssetLogReport = (extension) => {
        let lessorStr = lessor_name_id.map(item => (`(${item.id},${item.lessor_level})`)).toString()
        let lessee_ids = selectedLessee.map(item => (item.id))
        let asset_serial_number = assetId.map(item => ({ id: item?.id, asset_type: item?.asset_type }));
        let invoice_type = invoiceType.map(item => item.value);
        let lease_status = assetStatus.map(item => item.value);
        let engine_type = engineId.map(item => item.id)
        let apu_type = apuId.map(item => item.id)
        let aircraft_type = aircraftId.map(item => item.id)

        let validationInputs = {};
        validationInputs = {
            ...validationInputs,
            start_date: start_date ? '' : 'Please enter From Date',
            end_date: end_date ? '' : 'Please enter To Date',
        }
        if (start_date == 'Invalid date') {
            validationInputs = {
                ...validationInputs,
                start_date: 'Please enter From Date'
            }
        }
        if (end_date == 'Invalid date') {
            validationInputs = {
                ...validationInputs,
                end_date: 'Please enter To Date'
            }
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true)
            let payload ={
                file_type:extension,
                start_date:moment(start_date).format(backendDateFormat),
                end_date:moment(end_date).format(backendDateFormat),
                statement_type:'account',
                lessor_name_id:lessorStr,
                lessee:lessee_ids,
                asset_serial_number:asset_serial_number,
                invoice_type:invoice_type,
                lease_status:lease_status,
                engine_type:engine_type,
                apu_type:apu_type,
                aircraft_type:aircraft_type,
                country:selectedCountry.map(item=>item?.name)
            }
            globalPostService(`/console/export-statement-report/aircraft/`,payload)
                .then(response => {
                    setLoading(false);
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        setError({}); setStartDate(''); setEndDate(''); setLessor_name_id([]);
                        setLessee([]); setAircraftId([]); setApuId([]); setEngineId([]); setSelectedCountry([]); setAssetStatus([]); setInvoiceType([]); setAssetId([]);
                    } else {
                        enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    }
                });
        } else {
            setError(validationInputs)
        }
    }
    const onResetErrorKey = (keyParam) => {
        setError({ ...error, [keyParam]: '' })
    }
    const statusOptions = [{ label: "On Lease", value: 1 }, { label: "Off Lease", value: 2 }]
    const InvoiceOptions = [{ label: 'Reserve Invoice', value: '1' }, { label: 'Rental Invoice', value: '2' }, { label: 'Ad Hoc Invoice', value: '9' }, { label: 'Penalty Invoice', value: '3' }, { label: 'Debit Note Invoice', value: '4' }, { label: 'Credit Note Invoice', value: '5' }, { label: 'Security Deposit Invoice', value: '6' }, { label: 'Management Fee Invoice', value: '10' }]
    return (
        <Paper square>
            <Grid container spacing={0} alignItems='center'>
                <Grid item md={12}>
                    <div className='custom-rpt-card' style={{ minHeight: titanAviInstance ? "310px" : "200px" }}>
                        <div className='rpt-card-header'>
                            <Grid container spacing={1}>
                                <Grid item md={9}>
                                    <h4>Accounts Receivables Report</h4>
                                    <p>Open Invoices Report; AR Aging.</p>
                                </Grid>
                                <Grid item md={3}>
                                    {checkPermission('reports', 'custom_reports', 'EXP') ? <ExportMenu
                                        exportReportFn={(file) => exportAssetLogReport(file.extension)}
                                        files={[{ title: 'EXCEL', extension: 'xls' }, { title: 'CSV', extension: 'csv' }]}
                                    /> : null}
                                </Grid>
                            </Grid>
                        </div>
                        <div className='rpt-card-body'>
                            <Grid container spacing={1}>
                                <Grid item md={6}>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <KeyboardDatePicker
                                            required
                                            margin="normal"
                                            id="start_date"
                                            label="From Date"
                                            format={fieldDateFormat}
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            maxDate={moment()}
                                            value={start_date || null}
                                            error={error.start_date ? true : false}
                                            helperText={error.start_date ? error.start_date : ''}
                                            onChange={(data) => { setStartDate(('start_date', moment(data).format(backendDateFormat))); onResetErrorKey('start_date') }}
                                            inputVariant='outlined'
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item md={6}>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <KeyboardDatePicker
                                            required
                                            margin="normal"
                                            id="end_date"
                                            label="To Date"
                                            format={fieldDateFormat}
                                            disabled={!start_date ? true : false}
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            minDate={moment(start_date)}
                                            maxDate={moment(start_date).diff(moment(), 'month') === 0 ? moment(new Date()) : moment(start_date).add(300, 'M')}
                                            value={end_date || null}
                                            error={error.end_date ? true : false}
                                            helperText={error.end_date ? error.end_date : ''}
                                            onChange={(data) => { setEndDate(('end_date', moment(data).format(backendDateFormat))); onResetErrorKey('end_date') }}
                                            inputVariant='outlined'
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                {gaTelesisInstance ?
                                    <Grid item md={12}>
                                        <p className='lessor-select'> <span onClick={() => setAssetStatus(statusOptions)}>Select All Lease Status</span> {assetStatus.length ? <span style={{ marginLeft: '8px' }} onClick={() => setAssetStatus([])}>Remove All Lease Status</span> : null} </p>
                                        <Autocomplete
                                            options={statusOptions}
                                            getOptionLabel={option => option.label}
                                            id='lessor'
                                            value={assetStatus}
                                            labelKey="label"
                                            valueKey="value"
                                            multiple
                                            onChange={(e, data) => setAssetStatus(data)}
                                            renderInput={params => <TextField  {...params} label={'Lease Status'} margin="normal" placeholder={`Select Lease Status`} fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                        />
                                    </Grid> : null}
                                <Grid item md={12}>
                                    <p className='lessor-select'><span onClick={() => { setLessor_name_id(ownerList); setSelectAllLessor(true) }}>Select All {jetStreamInstance ? "Lessor/Holdco" : "Lessor"}</span>{lessor_name_id.length ? <span style={{ marginLeft: '8px' }} onClick={() => { setLessor_name_id([]); setSelectAllLessor(false) }} >Remove All {jetStreamInstance ? "Lessor/Holdco" : "Lessor"}</span> : null}</p>
                                    <Autocomplete
                                        options={ownerList}
                                        getOptionLabel={option => option.name}
                                        id='lessor'
                                        value={lessor_name_id}
                                        labelKey="name"
                                        valueKey="id"
                                        multiple
                                        onChange={(e, data) => setLessor_name_id(data)}
                                        renderInput={params => <TextField  {...params} label={jetStreamInstance ? "Lessor/Holdco" : "Lessor"} margin="normal" placeholder={`Select ${jetStreamInstance ? "Lessor/Holdco" : "Lessor"}`} fullWidth InputLabelProps={{ shrink: true }} onBlur={() => setUpdateForm(false)} onFocus={() => { setUpdateForm(true); setSelectAllLessor(false) }} variant='outlined' />}
                                    />
                                </Grid>
                                {gaTelesisInstance ? <>
                                    <Grid item md={12}>
                                        <p className='lessor-select'><span onClick={() => setLessee(lessee)}>Select All Lessee</span> {selectedLessee?.length ? <span style={{ marginLeft: '8px' }} onClick={() => { setLessee([]) }} >Remove All Lessee</span> : null} </p>
                                        <Autocomplete
                                            options={lessee}
                                            getOptionLabel={option => option.name}
                                            id='lessor'
                                            value={selectedLessee}
                                            multiple
                                            onChange={(e, data) => { setLessee(data) }}
                                            renderInput={params => <TextField  {...params} label={"Lessee"} margin="normal" placeholder={`Select Lessee`} fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                        />
                                    </Grid>
                                    <Grid item md={12}>
                                        <p className='lessor-select'><span onClick={() => { setAssetId(assetList) }}>Select All Asset</span>{assetId.length ? <span style={{ marginLeft: '8px' }} onClick={() => { setAssetId([]) }} >Remove All Asset</span> : null}</p>
                                        <Autocomplete
                                            options={assetList}
                                            getOptionLabel={option => option.asset_name}
                                            id='assetId'
                                            value={assetId}
                                            multiple
                                            onChange={(e, data) => setAssetId(data)}
                                            renderInput={params => <TextField error={error.assetId ? true : false} helperText={error.assetId ? error.assetId : ''} {...params} label="Asset" margin="normal" placeholder='Select Assets' onFocus={() => { onResetErrorKey('assetId'); }} fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                        />
                                    </Grid>
                                    <Grid item md={12}>
                                        <p className='lessor-select'><span onClick={() => { setAircraftId(aircraft) }}>Select All Aircraft Type</span>{aircraftId.length ? <span style={{ marginLeft: '8px' }} onClick={() => { setAircraftId([]) }} >Remove All Aircraft Type</span> : null}</p>
                                        <Autocomplete
                                            options={aircraft}
                                            getOptionLabel={option => option.name}
                                            id='aircraftId'
                                            value={aircraftId}
                                            multiple
                                            onChange={(e, data) => setAircraftId(data)}
                                            renderInput={params => <TextField {...params} label="Aircraft Type" margin="normal" placeholder='Select Asset Type' fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                        />
                                    </Grid>
                                    <Grid item md={12}>
                                        <p className='lessor-select'><span onClick={() => { setEngineId(engineTypes) }}>Select All Engine Type</span>{engineId.length ? <span style={{ marginLeft: '8px' }} onClick={() => { setEngineId([]) }} >Remove All Engine Type</span> : null}</p>
                                        <Autocomplete
                                            options={engineTypes}
                                            getOptionLabel={option => option.name}
                                            id='engineId'
                                            value={engineId}
                                            multiple
                                            onChange={(e, data) => setEngineId(data)}
                                            renderInput={params => <TextField {...params} label="Engine Type" margin="normal" placeholder='Select Engine Type' fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                        />
                                    </Grid>
                                    <Grid item md={12}>
                                        <p className='lessor-select'><span onClick={() => { setApuId(aircraft) }}>Select All APU Type</span>{apuId.length ? <span style={{ marginLeft: '8px' }} onClick={() => { setApuId([]) }} >Remove All APU Type</span> : null}</p>
                                        <Autocomplete
                                            options={apuTypes}
                                            getOptionLabel={option => option.name}
                                            id='apuId'
                                            value={apuId}
                                            multiple
                                            onChange={(e, data) => setApuId(data)}
                                            renderInput={params => <TextField {...params} label="APU Type" margin="normal" placeholder='Select APU Type' fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                        />
                                    </Grid>
                                    <Grid item md={12}>
                                        <p className='lessor-select'>
                                            <span onClick={() => setInvoiceType(InvoiceOptions)}>Select All Invoice Types</span>
                                            {invoiceType.length ? <span style={{ marginLeft: '8px' }} onClick={() => setInvoiceType([])}>Remove All Invoice Types</span> : null}
                                        </p>
                                        <Autocomplete
                                            options={InvoiceOptions}
                                            getOptionLabel={option => option.label}
                                            value={invoiceType}
                                            multiple
                                            onChange={(e, data) => setInvoiceType(data)}
                                            renderInput={params => <TextField {...params} label="Invoice Type" margin="normal" placeholder='Select Invoice Type' fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                        />
                                    </Grid>
                                    <Grid item md={12}>
                                        <p className='lessor-select'>
                                            <span onClick={() => setSelectedCountry(country)}>Select All Countries</span>
                                            {selectedCountry.length ? <span style={{ marginLeft: '8px' }} onClick={() => setSelectedCountry([])}>Remove All Countries</span> : null}
                                        </p>
                                        <Autocomplete
                                            options={country}
                                            getOptionLabel={option => option.name}
                                            value={selectedCountry}
                                            multiple
                                            onChange={(e, data) => setSelectedCountry(data)}
                                            renderInput={params => <TextField {...params} label="Country" margin="normal" placeholder='Select Country' fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                        />
                                    </Grid></> : null}
                            </Grid>
                        </div>
                    </div>
                </Grid>
            </Grid>
            {isLoading ? <PageLoader /> : null}
        </Paper>
    )
}
export default withRouter(CustAcStatement);